import React, { useContext } from "react";
import "./index.scss";
import BarInfo from "../../mediaContent/barInfo";
import { StepContext } from "../StepContext";
import { useTranslation } from "../../i18n";

const SelectionItem = ({
  itemKey,
  isSelected,
  select,
  preview,
  innerTitle,
  outerTitle,
  outerDescription,
  aboutClick,
  disabled = false,
  selectText = null
}) => {
  const {
    _t,
    language
  } = useTranslation();
  const {
    isPatient,
    openVideoViewer
  } = useContext(StepContext);

  function showAbout(key) {
    if (isPatient) {
      const selectedItem = BarInfo(language).find(el => el.type === key);

      if (selectedItem) {
        openVideoViewer(true, selectedItem.preview.video, selectedItem.title);
      }
    } else {
      aboutClick();
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: `selectionItemContainer ${disabled ? "disabled" : ""}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `selectionItem ${isSelected ? "active" : ""} `,
    onClick: () => !disabled ? select() : null
  }, /*#__PURE__*/React.createElement("img", {
    src: preview,
    className: "previewImg",
    alt: ""
  }), innerTitle && /*#__PURE__*/React.createElement("p", {
    className: "innerTitle"
  }, innerTitle), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "selectBtn",
    disabled: disabled
  }, selectText || _t("Выбрать"))), (outerTitle || outerDescription || aboutClick) && /*#__PURE__*/React.createElement("div", {
    className: "outerContent"
  }, outerTitle && /*#__PURE__*/React.createElement("div", {
    className: "outerTitle"
  }, outerTitle), outerDescription && /*#__PURE__*/React.createElement("div", {
    className: "outerDescription"
  }, outerDescription), aboutClick && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btnPrimary selectionBtnAbout",
    onClick: () => showAbout(itemKey)
  }, _t("Подробней"))));
};

export default SelectionItem;